<template>
  <v-container class="fill-height">
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3 lg4 offset-lg4 xl2 offset-xl5>
        <v-card class="login-card">
          <loading-indicator></loading-indicator>
          <v-layout class="text-center mb-5">
            <v-flex xs12>
              <h1 class="pt-5">Forgot Password</h1>
            </v-flex>
          </v-layout>
          <v-card-text>
            <v-form>
              <v-text-field v-if="this.successMessage == null" v-model="email" label="Email"></v-text-field>
              <div v-if="this.resetError != null" class="text-center error--text mt-3 mb-5 error-message">{{resetError}}</div>
              <div v-if="this.successMessage != null" class="text-center success--text mt-3 mb-5 success-message">{{successMessage}}</div>
              <v-btn raised class="my-2" block depressed large @click="sendForgotPassword(email)" color="accent">Submit</v-btn>
              <v-btn raised block outlined large @click="backToLogin" padding=10 color="accent">Back</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LoadingIndicator from '@/components/_layouts/LoadingIndicator'
export default {
  name: 'Forgot',
  created () {
    this.clearAccount()
  },
  data: () => ({
    email: null
  }),
  components: {
    LoadingIndicator
  },
  methods: {
    ...mapActions({
      sendForgotPassword: 'account/sendForgotPassword',
      clearAccount: 'account/clearAccount'
    }),
    backToLogin () {
      this.clearAccount()
      this.$router.push('/')
    }
  },
  computed: {
    ...mapGetters({
      resetError: 'account/error',
      successMessage: 'account/success'
    })
  }
}
</script>

<style scoped>
  .login-card {
    margin-top: 100px;
    padding: 0 20px 20px 20px;
  }
  .error-message {
    height: 20px;
    font-weight: bold;
  }
  @media only screen and (max-width: 350px) {
    .login-card {
      margin-top: 70px;
    }
  }
</style>
